import React from 'react'
import { createUseStyles } from 'react-jss'

const useStyles = createUseStyles(() => ({
    control: {
        position: 'relative',
        marginBottom: '20px',
    },
}))

const FormControl: React.FC = ({ children }) => {
    const classes = useStyles()

    return <div className={classes.control}>{children}</div>
}

export { FormControl }
